export { default as ProductListTemplate } from './ProductListTemplate';
export { default as ProductDetailTemplate } from './ProductDetailTemplate';
export { default as ProductInventoryListTemplate } from './ProductInventoryListTemplate';
export { default as CreateBoxTemplate } from './CreateBoxTemplate';
export { default as DescriptionTemplate } from './DescriptionTemplate';
export { default as ProductHistoryLogListTemplate } from './ProductHistoryLogListTemplate';
export { default as ProductActivityTemplate } from './ProductActivityTemplate';
export { default as AddExistingProductModalContentTemplate } from './AddExistingProductModalContentTemplate';
export { default as UpdateProductPartModalContentTemplate } from './UpdateProductPartModalContentTemplate';
export { default as ProductImportTemplate } from './ProductImportTemplate';
export { default as UpdateInventoryLogTemplate } from './UpdateInventoryLogTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/index.js